import type { Editor } from '@tiptap/core'
import Placeholder from '@tiptap/extension-placeholder'
import { liveEditor } from './editorLiveness'

// TipTap reads an extension's options once, when the editor is built, so a
// placeholder configured as a plain string never changes after that. This one
// asks for the current text each time it draws, so a composer can learn its
// placeholder after it mounted (a direct message naming the other person).
export function LivePlaceholder(getPlaceholder: () => string) {
    return Placeholder.configure({ placeholder: () => getPlaceholder() })
}

// Draws the placeholder again after its text changed. The transaction changes
// nothing: no content edit, no update event, nothing for undo.
export function redrawPlaceholder(editor: Editor | null | undefined) {
    const live = liveEditor(editor)
    if (!live) return
    live.view.dispatch(live.state.tr.setMeta('addToHistory', false))
}
